import * as Yup from 'yup';
import createCargoFormModel from './createParameterFormModel';

const {
  formField: {
    llegadas_tarde,
    salidas_tarde,
    salario_minimo,
    auxilio_transporte,
    interes_cesantias,
    year,
    horasSemanales,
    horasMensuales
  }

} = createCargoFormModel;


export default [

  Yup.object().shape({ 
    [llegadas_tarde.name]: Yup.string().required(`${llegadas_tarde.requiredErrorMsg}`),    
    [salidas_tarde.name]: Yup.string().required(`${salidas_tarde.requiredErrorMsg}`),
    [salario_minimo.name]: Yup.string().required(`${salario_minimo.requiredErrorMsg}`),    
    [auxilio_transporte.name]: Yup.string().required(`${auxilio_transporte.requiredErrorMsg}`),
    [interes_cesantias.name]: Yup.string().required(`${interes_cesantias.requiredErrorMsg}`),    
    [year.name]: Yup.string().required(`${year.requiredErrorMsg}`),
    [horasSemanales.name]: Yup.number().required(`${horasSemanales.requiredErrorMsg}`),
    [horasMensuales.name]: Yup.number().required(`${horasMensuales.requiredErrorMsg}`),
  })
  
];  

    